import { render, staticRenderFns } from "./Lotteries.vue?vue&type=template&id=2494294c&"
import script from "./Lotteries.vue?vue&type=script&lang=js&"
export * from "./Lotteries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports